import { render, staticRenderFns } from "./FormType.vue?vue&type=template&id=a79b12e0"
import script from "./FormType.vue?vue&type=script&lang=js"
export * from "./FormType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports